import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import SidebarDashboard from "../../components/SidebarDashboard";
import {
  getEmployeeMonitor,
  validateEmployeeDescriptor,
} from "../../redux/evaluacion_desempenio/EmployeeMonitor/actions";
import Multiselect from "../../components/Clima/Multiselect";
import { getDivision } from "../../redux/division/actions";
import { getOrgs } from "../../redux/organization/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import { useHistory } from "react-router-dom";
import {
  getCompanyResponsibleSelects
} from "../../redux/CompanyResponsibles/actions"
import ReactChipInput from "react-chip-input";

const EmployeeMonitor = (props) => {
  const filters = [
    { id: "nombre", desc: "Nombre del empleado" },
    { id: "codigo", desc: "Código del empleado" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('[""]');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [_orgs, setOrgs] = useState([]);
  const [_orgsId, setOrgsId] = useState("");
  const [validOrgs, setValidOrgs] = useState(true);
  const [submitOrgs, setSubmitOrgs] = useState(false);
  const [_division, setDivision] = useState([]);
  const [_divisionId, setDivisionId] = useState("");
  const [validDivision, setValidDivision] = useState(true);
  const [submitDivision, setSubmitDivision] = useState(false);
  const [_areas, setAreas] = useState([]);
  const [_areasId, setAreasId] = useState("");
  const [validAreas, setValidAreas] = useState(true);
  const [submitAreas, setSubmitAreas] = useState(false);
  const [chips, setChips] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre del empleado",
  });
  const [view, setView] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    // busqueda: Yup.string().notRequired(),
  });

  const userRoles = useSelector((store) => store.auth.userRoles);
  const username = useSelector((store) => store.auth.username);



  const {
    loading,
    saveLoading,
    employeeMonitorsLength,
    employeeMonitors,
    employeeMonitorError,
    formError,
  } = useSelector((store) => store.employeeMonitor);
  const pages = Math.ceil(employeeMonitorsLength / limit);

  const { division } = useSelector((store) => store.division);
  const divisionLoading = useSelector((store) => store.division.loading);

  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);
  const {
    companyResponsiblesSelect
  } = useSelector((store) => store.companyResponsible);

  var listOrgs = [];

  (userRoles.includes("administrador") ? data: companyResponsiblesSelect?.[0]?.empresas)?.map((item) => {
    listOrgs = [
      ...listOrgs,
      { value: item.id, label: item.nombre.toUpperCase() },
    ];
  });

  let listDivision = [];

  division.map((task) => {
    listDivision = [
      ...listDivision,
      {
        value: task.id,
        label: task.descripcion,
      },
    ];
  });

  var listAreas = [];

  areas
    .filter((e) => e.codigo && e.nombre)
    .map((item) => {
      listAreas = [
        ...listAreas,
        {
          value: item.id,
          codigo: item.codigo,
          label: `${item.codigo ? item.codigo : ""} / ${
            item.nombre ? item.nombre.toUpperCase() : ""
          }`,
        },
      ];
    });

  const columns = [
    {
      Header: "Código:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => <div>{value.row.original.codigo}</div>,
    },
    {
      Header: "Nombre:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => <div>{value.row.original.nombre}</div>,
    },
    {
      Header: "Función:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_funcion &&
          value.row.original.list_funcion[0].descripcion
            ? value.row.original.list_funcion[0].descripcion
            : null}
        </div>
      ),
    },
    {
      Header: "División:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.Division_List &&
          value.row.original.Division_List[0].id
            ? value.row.original.Division_List[0].descripcion
            : null}
        </div>
      ),
    },
    {
      Header: "Jefe inmediato:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_jefe_inmediato &&
          value.row.original.list_jefe_inmediato.length > 0 &&
          value.row.original.list_jefe_inmediato[0].nombre
            ? value.row.original.list_jefe_inmediato[0].nombre
            : null}
        </div>
      ),
    },
    {
      Header: "Fecha de ingreso:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_ingreso).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Evaluaciones realizadas:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_pruebas_realizadas}/
          {value.row.original.total_pruebas}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Ir a monitor de evaluaciones</Tooltip>}
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              // disabled={value.row.original.total_pruebas === 0}
              onClick={
                () =>
                  history.push(
                    `/evaluacion-desempenio/monitor-de-evaluación/${
                      value.row.original.id
                    }/${value.row.original.nombre}/${
                      value.row.original.list_funcion &&
                      value.row.original.list_funcion[0].id
                        ? value.row.original.list_funcion[0].id
                        : "No asignado"
                    }/${
                      value.row.original.list_funcion &&
                      value.row.original.list_funcion[0].descripcion &&
                      value.row.original.list_funcion[0].descripcion !== ""
                        ? value.row.original.list_funcion[0].descripcion.replaceAll(
                            "/",
                            "-"
                          )
                        : "No asignado"
                    }/${
                      value.row.original.Division_List &&
                      value.row.original.Division_List[0].id
                        ? value.row.original.Division_List[0].id
                        : "No asignado"
                    }/${
                      value.row.original.Division_List &&
                      value.row.original.Division_List[0].descripcion &&
                      value.row.original.Division_List[0].descripcion !== ""
                        ? value.row.original.Division_List[0].descripcion.replaceAll(
                            "/",
                            "-"
                          )
                        : "No asignado"
                    }/${
                      value.row.original.empresa_id &&
                      value.row.original.empresa_id[0]
                        ? value.row.original.empresa_id[0]
                        : null
                    }/${
                      value.row.original.clasificacion_empleado
                        ? value.row.original.clasificacion_empleado
                        : null
                    }`
                  )
                // dispatch(validateEmployeeDescriptor({
                //   codigo_empleado:value.row.original.codigo
                // }, value.row.original,history))
              }
            >
              <i className="material-icons">dashboard</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getEmployeeMonitor = (
    offs = offset,
    lim = limit,
    filt = filter,
    orgas = _orgsId,
    division = _divisionId,
    areas = _areasId,
    viw = view
  ) =>
    dispatch(
      getEmployeeMonitor({
        offset: offs,
        limit: lim,
        // tipo_busqueda_1: tipoBusqueda.id,
        empleado: filt,
        // tipo_busqueda_2: "empresa",
        empresa: orgas,
        // tipo_busqueda_3: "division",
        departamento: division,
        // tipo_busqueda_4: "area",
        unidad_organizativa: areas,
        vista: viw,
      })
    );

  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Responsable_Evaluacion" ||
          usr === "alta_direccion"
      )[0];
      setView(rolActual);
      _getEmployeeMonitor(
        offset,
        limit,
        filter,
        _orgsId,
        _divisionId,
        _areasId,
        rolActual
      );
    }
  }, [userRoles]);

  useEffect(() => {
    // _getEmployeeMonitor();
    dispatch(getDivision({}));
    dispatch(getOrgs(parseInt(2)));
    dispatch(getAreasJerarquia({}, 2, true));
    dispatch(getCompanyResponsibleSelects({
      filter_kwargs: {"username": username}
    }))
  }, []);

  useEffect(() => {
    if (showModal) {
      document.getElementsByName("chipInput")[0].placeholder = "Empleado";
    }
  }, [showModal]);

  const onOpenSearch = () => {
    setChips([]);
    setValidOrgs(true);
    setSubmitOrgs(false);
    setOrgs([]);
    setValidDivision(true);
    setSubmitDivision(false);
    setDivision([]);
    setValidAreas(true);
    setSubmitAreas(false);
    setAreas([]);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitor(oOffset, limit, `["${e.target.filter.value}"]`);
  };

  // const evaluarValues = (valor) => {
  //   if (valor.length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const onSearchForm = async (req) => {
    // setSubmitOrgs(true);
    // setSubmitDivision(true);
    // setSubmitAreas(true);
    // const isOrgValid = evaluarValues(_orgs);
    // const isDivisionValid = evaluarValues(_division);
    // const isAreasValid = evaluarValues(_orgs);
    // setValidOrgs(isOrgValid);
    // setValidDivision(isDivisionValid);
    // setValidAreas(isAreasValid);
    // if (!isOrgValid || !isDivisionValid || !isAreasValid) {
    //   return;
    // }
    let idOrg = "";
    _orgs.map((item, index) => {
      if (parseInt(index) === 0) {
        idOrg += `["${item.label}"`;
        // if (_orgs.length > 0) {
        //   idOrg += `,`;
        // }
      } else {
        idOrg += `"${item.label}"`;
      }
      if (!_orgs[parseInt(index) + 1]) {
        idOrg += `]`;
      } else {
        idOrg += `,`;
      }
    });
    setOrgsId(idOrg);
    let idDiv = "";
    _division.map((item, index) => {
      if (parseInt(index) === 0) {
        idDiv += `["${item.label}"`;
        // if (_division.length > 0) {
        //   idDiv += `,`;
        // }
      } else {
        idDiv += `"${item.label}"`;
      }
      if (!_division[parseInt(index) + 1]) {
        idDiv += `]`;
      } else {
        idDiv += `,`;
      }
    });
    setDivisionId(idDiv);
    let idArea = "";
    _areas.map((item, index) => {
      if (parseInt(index) === 0) {
        idArea += `["${item.codigo}"`;
        // if (_areas.length > 0) {
        //   idArea += `,`;
        // }
      } else {
        idArea += `"${item.codigo}"`;
      }
      if (!_areas[parseInt(index) + 1]) {
        idArea += `]`;
      } else {
        idArea += `,`;
      }
    });
    let idChips = "";
    chips.map((item, index) => {
      if (parseInt(index) === 0) {
        idChips += `["${item}"`;
        // if (_areas.length > 0) {
        //   idArea += `,`;
        // }
      } else {
        idChips += `"${item}"`;
      }
      if (!chips[parseInt(index) + 1]) {
        idChips += `]`;
      } else {
        idChips += `,`;
      }
    });
    setAreasId(idArea);
    setFilter(idChips);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitor(oOffset, limit, idChips, idOrg, idDiv, idArea);
    setShowModal(false);
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter('[""]');
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitor(
      offset,
      limit,
      '[""]',
      "",
      "",
      "",
      e.currentTarget.value
    );
    setOrgsId("");
    setDivisionId("");
    setAreasId("");
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitor(oOffset, limit, `["${oSearch}"]`);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <Col
              xs="auto"
              className="d-flex flex-wrap justify-content-start align-items-center"
            >
              <Row className="d-flex flex-wrap justify-content-start align-items-center">
                <div
                  style={{
                    width: "520px",
                  }}
                >
                  <h6 className="text-uppercase">
                    <b>Monitor de colaboradores</b>
                  </h6>
                </div>
              </Row>
            </Col>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {
                  // userRoles.length > 0 &&
                  // (userRoles.includes("jefe") ||
                  //   userRoles.includes("alta_direccion"))
                  view === "jefe" || view === "alta_direccion" ? (
                    <Col xs="auto">
                      <Row>
                        <Form.Label column xs="auto">
                          <b>Buscar:</b>
                        </Form.Label>
                        <Col md="8" xs="auto" className="px-0">
                          <Form.Control
                            name="filter"
                            id="filter"
                            // placeholder={`${tipoBusqueda.desc}`}
                            placeholder="Código o nombre del empleado"
                            className="rounded-pill form-control-sm"
                            type="search"
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                  ) : null
                }
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    {/* {userRoles.length > 0 &&
                      userRoles.includes("jefe") &&
                      !(
                        userRoles.includes("administrador") ||
                        userRoles.includes("Responsable_Evaluacion_Desempeño")
                      ) && (
                        <Dropdown className="ml-1 mr-1">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      )} */}
                    {
                      // userRoles.length > 0 &&
                      //   (userRoles.includes("administrador") ||
                      //     userRoles.includes("Responsable_Evaluacion"))
                      view === "administrador" ||
                      view === "Responsable_Evaluacion" ? (
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle"
                          onClick={() => onOpenSearch()}
                        >
                          <i className="material-icons">search</i>
                        </Button>
                      ) : null
                    }
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <Row className="mx-2 px-1 justify-content-start align-items-center flex-nowrap">
            {userRoles.filter(
              (usr) =>
                usr === "jefe" ||
                usr === "administrador" ||
                usr === "Responsable_Evaluacion" ||
                usr === "alta_direccion"
            ).length > 1 ? (
              <>
                <Col xs="auto">
                  <h6>
                    <b>Ver como:</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {/* loadingAuth, users */}
                  <Form.Control
                    as="select"
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    onChange={onSearchRole}
                    style={{ minWidth: "174px" }}
                  >
                    {userRoles
                      .filter(
                        (usr) =>
                          usr === "jefe" ||
                          usr === "administrador" ||
                          usr === "Responsable_Evaluacion" ||
                          usr === "alta_direccion"
                      )
                      .map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                  </Form.Control>
                </Col>
              </>
            ) : null}
          </Row>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            employeeMonitorsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={employeeMonitors} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={employeeMonitorsLength}
                  pages={pages}
                  pagFunc={_getEmployeeMonitor}
                />
              </>
            )
          )}
          {!loading &&
            employeeMonitorsLength === 0 &&
            employeeMonitorError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, contacte al administrador para mas
                información
              </Alert>
            )}
          {!!employeeMonitorError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {employeeMonitorError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        {/* <Formik
          validationSchema={schema}
          onSubmit={onSearchForm}
          // initialValues={{
          //   busqueda: "",
          // }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => ( */}
        {/* <Form */}
        {/* // onSubmit={handleSubmit} noValidate validated={validated} */}
        {/* > */}
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">Búsqueda avanzada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!formError && (
            <Alert variant="danger" className="my-1">
              {formError}
            </Alert>
          )}
          <Form.Group as={Row}>
            <Form.Label column sm={3}>
              Empresa:
            </Form.Label>
            <Col sm={9}>
              <Row className="d-flex flex-wrap align-items-center">
                <Col sm={loadingOrgs ? "10" : "12"}>
                  <Multiselect
                    options={listOrgs}
                    value={_orgs}
                    onChange={setOrgs}
                    isValid={validOrgs}
                    isDisabled={loadingOrgs}
                    isSubmit={submitOrgs}
                  />
                </Col>
                {loadingOrgs && (
                  <Col sm={1}>
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3}>
              División:
            </Form.Label>
            <Col sm={9}>
              <Row className="d-flex flex-wrap align-items-center">
                <Col sm={divisionLoading ? "10" : "12"}>
                  <Multiselect
                    options={listDivision}
                    value={_division}
                    onChange={setDivision}
                    isValid={validDivision}
                    isDisabled={divisionLoading}
                    isSubmit={submitDivision}
                  />
                </Col>
                {divisionLoading && (
                  <Col sm={1}>
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-md-0">
            <Form.Label column sm={3}>
              Unidad organizativa:
            </Form.Label>
            <Col sm={9}>
              <Row className="d-flex flex-wrap align-items-center">
                <Col sm={loadingAreas ? "10" : "12"}>
                  <Multiselect
                    options={listAreas}
                    value={_areas}
                    onChange={setAreas}
                    isValid={validAreas}
                    isDisabled={loadingAreas}
                    isSubmit={submitAreas}
                  />
                </Col>
                {loadingAreas && (
                  <Col sm={1}>
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={3}>
              Empleado:
            </Form.Label>
            <Col sm={9}>
              <Row>
                <Col sm={12}>
                  <ReactChipInput
                    chips={chips}
                    placeholder="Código o nombre del empleado"
                    onSubmit={(value) => {
                      const _chips = chips.slice();
                      _chips.push(value);
                      setChips(_chips);
                    }}
                    onRemove={(index) => {
                      const _chips = chips.slice();
                      _chips.splice(index, 1);
                      setChips(_chips);
                    }}
                  />
                  {/* <Form.Control
                          id="busqueda"
                          name="busqueda"
                          className="rounded-pill"
                          required
                          type="text"
                          value={values.busqueda}
                          // placeholder={`${tipoBusqueda.desc}`}
                          placeholder="Código o nombre del empleado"
                          onBlur={handleBlur("busqueda")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={touched.busqueda && !!errors.busqueda}
                        ></Form.Control> */}
                </Col>
                {/* <Col
                        sm={1}
                        className="d-flex flex-wrap justify-content-center align-items-center"
                      >
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Col> */}
              </Row>
              {/* <div>
                      <small className="text-muted px-3">
                        <b>Búsqueda por: {tipoBusqueda.desc}</b>
                      </small>
                    </div> */}
              <div>
                <small className="text-muted mx-1">
                  <b>Búsqueda por: Código o nombre de empleado</b>
                </small>
              </div>
              <div>
                <small className="text-muted mx-1">
                  <b>
                    (Para agregar los elementos a la lista, presione la tecla
                    "Enter")
                  </b>
                </small>
              </div>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModal(false)}
          >
            Cerrar
          </Button>
          <Button
            className="rounded-pill"
            disabled={loading || loadingOrgs || divisionLoading || loadingAreas}
            variant="primary"
            type="button"
            onClick={(e) => onSearchForm(e)}
          >
            {(loading || loadingOrgs || divisionLoading || loadingAreas) && (
              <Spinner
                className="mr-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            Buscar
          </Button>
        </Modal.Footer>
        {/* </Form> */}
        {/* )}
        </Formik> */}
      </Modal>
    </>
  );
};

export default EmployeeMonitor;
